/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useRef } from 'react';

import PropTypes from 'prop-types';

import {
  Modal,
  ModalContent,
  ModalHeader,
  Space,
  Text,
} from '@cashfree-intl/coherent';
import useClickOutside from 'utils/hooks';
import StepChip from 'components/StepChip';
import CustomIcon from 'components/CustomIcons';

const Wrapper = props => {
  const { closeModal, step, headerText } = props;

  const modalRef = useRef(null);
  useClickOutside(modalRef, closeModal);

  return (
    <Modal className="enable-payment-methods-modal" open ref={modalRef}>
      <ModalHeader>
        <Space
          justifyContent="space-between"
          alignItems="center"
          className="full-width"
        >
          <Space alignItems="center" gap={1}>
            <Text variant="h20">{headerText}</Text>
            <StepChip>Step {step + 1}/2</StepChip>
          </Space>
          <div
            className="close-modal"
            data-event-name="EnablePaymentMethodsModal_Icon_Close"
            data-ignore-inner-text="true"
            onClick={closeModal}
          >
            <CustomIcon componentName="CLOSE" />
          </div>
        </Space>
      </ModalHeader>
      <ModalContent>{props.children}</ModalContent>
    </Modal>
  );
};

Wrapper.propTypes = {
  closeModal: PropTypes.func.isRequired,
  step: PropTypes.number.isRequired,
  children: PropTypes.node.isRequired,
  headerText: PropTypes.string.isRequired,
};

export default Wrapper;
